export default "__VITE_ASSET__8b7442b9__"